import { t } from '@lingui/core/macro';

import { useEnableSchema } from '@rover/components/src/microdata';
import { Box } from '@rover/kibble/core';

import DesktopAvatar from './DesktopAvatar';
import { Props } from './ImageColumn.common';
import MobileAvatar from './MobileAvatar';

const ImageColumn = ({
  displayExpanded,
  desktopProfileImage,
  mobileProfileImage,
  shortName,
  lazy = true,
  badge,
  cardTreatment,
}: Props): React.ReactElement => {
  const description = t`Sitter Profile Image: ${shortName}`;
  const enableSchema = useEnableSchema();

  return (
    <>
      {enableSchema && <meta itemProp="image" content={desktopProfileImage} />}
      <Box display={['block', 'none']} flexShrink="0">
        <MobileAvatar
          imageUrl={mobileProfileImage}
          badge={badge}
          description={description}
          cardTreatment={cardTreatment}
        />
      </Box>
      <Box display={['none', 'block']} flexShrink="0">
        <DesktopAvatar
          imageUrl={desktopProfileImage}
          lazy={!!lazy}
          badge={badge}
          displayExpanded={displayExpanded}
          description={description}
          cardTreatment={cardTreatment}
        />
      </Box>
    </>
  );
};

export default ImageColumn;
